import React from "react";
import moment from "moment";

interface HotSpotInfoTableType {
  hotspot?: any;
  dataType: "Thailand" | "Asean";
  columnName: string;
  startItem?: number;
}

function HotSpotInfoTable({
  hotspot,
  dataType,
  columnName,
  startItem = 1,
}: HotSpotInfoTableType) {
  return (
    <div className="w-full h-full">
      <table className="table-auto w-full">
        {dataType === "Thailand" ? (
          <>
            <thead className="bg-primary-main bg-opacity-80 ">
              <tr>
                <th
                  rowSpan={2}
                  className="min-w-[80px] rounded-l-2xl text-sm text-primary-contrast font-medium"
                >
                  ลำดับ
                </th>
                {hotspot[0]?.provinceName && (
                  <th
                    rowSpan={2}
                    className="min-w-[150px] text-sm text-primary-contrast font-medium "
                  >
                    จังหวัด
                  </th>
                )}
                {hotspot[0]?.districtName && (
                  <th
                    rowSpan={2}
                    className="min-w-[150px] text-sm text-primary-contrast font-medium "
                  >
                    อำเภอ
                  </th>
                )}
                <th
                  rowSpan={2}
                  className={`${
                    hotspot[0].districtName || hotspot[0].provinceName
                      ? "min-w-[150px]"
                      : "min-w-[280px]"
                  } text-sm text-primary-contrast font-medium`}
                >
                  {columnName}
                </th>
                <th
                  rowSpan={2}
                  className="min-w-[80px] text-sm  text-primary-contrast font-medium"
                >
                  รวม
                </th>
                <th
                  colSpan={3}
                  className="min-w-[300px]  text-sm text-primary-contrast font-medium pt-2"
                >
                  อนุรักษ์
                </th>
                <th
                  colSpan={3}
                  className="min-w-[300px]  text-sm text-primary-contrast font-medium pt-2"
                >
                  เขต สปก.
                </th>
                <th
                  colSpan={3}
                  className="min-w-[300px]  pr-2  text-sm text-primary-contrast font-medium pt-2"
                >
                  ป่าสงวนแห่งชาติ
                </th>
                <th
                  colSpan={3}
                  className="min-w-[300px]  pr-2  text-sm text-primary-contrast font-medium pt-2"
                >
                  พื้นที่ริมทางหลวง(50เมตร)
                </th>
                <th
                  colSpan={3}
                  className="min-w-[300px]  pr-2  text-sm text-primary-contrast font-medium pt-2"
                >
                  พื้นที่เกษตร
                </th>
                <th
                  colSpan={3}
                  className="min-w-[300px]  pr-2  rounded-tr-2xl text-sm text-primary-contrast font-medium pt-2"
                >
                  ชุมชนและอื่น ๆ
                </th>
              </tr>
              <tr>
                <th className="w-[100px] pb-2 text-xs text-primary-contrast font-medium">
                  รอดำเนินการ
                </th>
                <th className="w-[100px] pb-2 text-xs  text-primary-contrast font-medium">
                  กำลังดำเนินการ
                </th>
                <th className="w-[100px] pb-2 text-xs text-primary-contrast font-medium">
                  ดำเนินการแล้วเสร็จ
                </th>
                <th className="w-[100px] pb-2 text-xs text-primary-contrast font-medium">
                  รอดำเนินการ
                </th>
                <th className="w-[100px] pb-2 text-xs  text-primary-contrast font-medium">
                  กำลังดำเนินการ
                </th>
                <th className="w-[100px] pb-2 text-xs text-primary-contrast font-medium">
                  ดำเนินการแล้วเสร็จ
                </th>
                <th className="w-[100px] pb-2 text-xs text-primary-contrast font-medium">
                  รอดำเนินการ
                </th>
                <th className="w-[100px] pb-2 text-xs  text-primary-contrast font-medium">
                  กำลังดำเนินการ
                </th>
                <th className="w-[100px] pb-2 text-xs text-primary-contrast font-medium">
                  ดำเนินการแล้วเสร็จ
                </th>
                <th className="w-[100px] pb-2 text-xs text-primary-contrast font-medium">
                  รอดำเนินการ
                </th>
                <th className="w-[100px] pb-2 text-xs  text-primary-contrast font-medium">
                  กำลังดำเนินการ
                </th>
                <th className="w-[100px] pb-2 text-xs text-primary-contrast font-medium">
                  ดำเนินการแล้วเสร็จ
                </th>
                <th className="w-[100px] pb-2 text-xs text-primary-contrast font-medium">
                  รอดำเนินการ
                </th>
                <th className="w-[100px] pb-2 text-xs text-primary-contrast font-medium">
                  กำลังดำเนินการ
                </th>
                <th className="w-[100px] pb-2 text-xs text-primary-contrast font-medium">
                  ดำเนินการแล้วเสร็จ
                </th>
                <th className="w-[100px] pb-2 text-xs text-primary-contrast font-medium">
                  รอดำเนินการ
                </th>
                <th className="w-[100px] pb-2 text-xs text-primary-contrast font-medium">
                  กำลังดำเนินการ
                </th>
                <th className="w-[100px] pb-2 rounded-br-2xl text-xs text-primary-contrast font-medium ">
                  ดำเนินการแล้วเสร็จ
                </th>
              </tr>
            </thead>
            <tbody>
              {hotspot?.map((data: any, index: number) => (
                <tr
                  key={startItem + index + 1}
                  className="border-b-[1px] border-gray-1"
                >
                  <td className="w-[5%] text-center text-sm font-normal text-text-primary py-1">
                    {startItem + index + 1}
                  </td>
                  {data.provinceName && (
                    <td className="w-[15%] text-center text-sm font-normal text-text-primary py-1">
                      {data?.provinceName}
                    </td>
                  )}
                  {data.districtName && (
                    <td className="w-[15%] text-center text-sm font-normal text-text-primary py-1">
                      {data?.districtName}
                    </td>
                  )}
                  <td
                    className={`w-[15%] ${
                      data.districtName || data.provinceName
                        ? "text-center"
                        : ""
                    } text-sm font-normal text-text-primary py-1`}
                  >
                    {data?.name}
                  </td>
                  <td className="w-[5%] text-center text-sm font-normal text-text-primary py-1">
                    {data.total}
                  </td>

                  {data?.lu_code_1 ? (
                    <>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_1?.pending
                          ? data?.lu_code_1?.pending
                          : 0}
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_1?.inprogress
                          ? data?.lu_code_1?.inprogress
                          : 0}
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_1?.complete
                          ? data?.lu_code_1?.complete
                          : 0}
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                    </>
                  )}

                  {data?.lu_code_2 ? (
                    <>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_2?.pending
                          ? data?.lu_code_2?.pending
                          : 0}
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_2?.inprogress
                          ? data?.lu_code_2?.inprogress
                          : 0}
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_2?.complete
                          ? data?.lu_code_2?.complete
                          : 0}
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                    </>
                  )}

                  {data?.lu_code_3 ? (
                    <>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_3?.pending
                          ? data?.lu_code_3?.pending
                          : 0}
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_3?.inprogress
                          ? data?.lu_code_3?.inprogress
                          : 0}
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_3?.complete
                          ? data?.lu_code_3?.complete
                          : 0}
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                    </>
                  )}

                  {data?.lu_code_4 ? (
                    <>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_4?.pending
                          ? data?.lu_code_4?.pending
                          : 0}
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_4?.inprogress
                          ? data?.lu_code_4?.inprogress
                          : 0}
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_4?.complete
                          ? data?.lu_code_4?.complete
                          : 0}
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                    </>
                  )}

                  {data?.lu_code_5 ? (
                    <>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_5?.pending
                          ? data?.lu_code_5?.pending
                          : 0}
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_5?.inprogress
                          ? data?.lu_code_5?.inprogress
                          : 0}
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_5?.complete
                          ? data?.lu_code_5?.complete
                          : 0}
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                    </>
                  )}

                  {data?.lu_code_6 ? (
                    <>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_6?.pending
                          ? data?.lu_code_6?.pending
                          : 0}
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_6?.inprogress
                          ? data?.lu_code_6?.inprogress
                          : 0}
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        {data?.lu_code_6?.complete
                          ? data?.lu_code_6?.complete
                          : 0}
                      </td>
                    </>
                  ) : (
                    <>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                      <td className="w-[8.88%] text-center text-sm font-normal text-text-primary py-1">
                        0
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </>
        ) : (
          dataType === "Asean" && (
            <>
              <>
                <thead className="bg-primary-main bg-opacity-80 ">
                  <tr>
                    <th className="rounded-l-2xl text-sm text-primary-contrast font-medium">
                      ลำดับ
                    </th>
                    <th className="text-sm text-primary-contrast font-medium ">
                      ประเทศ
                    </th>
                    <th className="text-sm text-primary-contrast font-medium pt-2">
                      ระบบ VIIRS
                    </th>
                    <th className="text-sm text-primary-contrast font-medium pt-2">
                      ระบบ MODIS
                    </th>
                    <th className="pr-2  text-sm text-primary-contrast font-medium pt-2">
                      จำนวนจุดทั้งหมด
                    </th>
                    <th className="pr-2  text-sm text-primary-contrast font-medium pt-2 rounded-r-2xl">
                      ข้อมูลล่าสุด
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {hotspot?.map((data: any, index: number) => (
                    <tr
                      key={startItem + index + 1}
                      className="border-b-[1px] border-gray-1"
                    >
                      <td className="text-center text-sm font-normal text-text-primary py-1">
                        {startItem + index + 1}
                      </td>
                      <td className="text-sm font-normal text-text-primary py-1">
                        {data?.name}
                      </td>
                      <td className="text-sm font-normal text-text-primary py-1 text-center">
                        {data?.VIIRS ? data?.VIIRS : 0}
                      </td>
                      <td className="text-sm font-normal text-text-primary py-1 text-center">
                        {data?.MODIS ? data?.MODIS : 0}
                      </td>
                      <td className="text-sm font-normal text-text-primary py-1 text-center">
                        {data?.total ? data?.total : 0}
                      </td>
                      {data?.max_timestamp ? (
                        <td className="text-sm font-normal text-text-primary py-1 text-center">
                          {moment(new Date(data.max_timestamp)).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                      ) : (
                        <td className="text-sm font-normal text-text-primary py-1 text-center">
                          {moment(new Date()).format("DD/MM/YYYY")}
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </>
            </>
          )
        )}
      </table>
    </div>
  );
}

export default HotSpotInfoTable;
